import * as PID from './publisherIds'

export const publishersWithAdditionalAssetsForVideo = [
  PID.PM,
  PID.AMERICANAS,
  PID.DPSP,
  PID.RM_TESTES_PUBLISHER,
  PID.NEWTAILPARTNERBR,
  PID.CB,
  PID.CB_STAGING,
  PID.BEMOL_PID,
  PID.BEMOL_QA_PID,
  PID.SUPER_XTRA,
  PID.AUCHAN_POC,
  PID.TENDA
]
